import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from './config.service';
import { Injectable } from '@angular/core';
@Injectable()
export class BaseUrl implements HttpInterceptor {
  constructor(private configService: ConfigService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const duplicate = req.clone({
      url: req.url.startsWith('http') ? req.url : `${this.configService.getValue('BASE_URL')}${req.url}`
    });
    return next.handle(duplicate);
  }
}

export const BaseUrlInterceptor = { provide: HTTP_INTERCEPTORS, useClass: BaseUrl, multi: true };
